import Vue from "vue";
import VueCookies from 'vue-cookies';

import httpClient from '@/bundles/http-client';
import datetime from "@/filters/datetime";
import numbers from "@/filters/numbers";
import VueAxios from "@/plugins/axios";
import vuetify from "@/plugins/vuetify";
import eventBus from "@/shared/event-bus";
import store from "@/store";
import {VApp} from "vuetify/lib";

function createApp(app, element, props = {}, router = {}, makeSureAppExists = false) {
    if (makeSureAppExists) {
        const vuetifyAppEl = document.getElementById('app');

        if (!vuetifyAppEl) {
            const appDiv = document.createElement('div');
            document.body.append(appDiv);
            createApp(VApp, appDiv);
        }
    }

    Vue.use(VueAxios, httpClient);
    Vue.use(VueCookies);
    Vue.filter("formatNumber", numbers.formatNumber);

    Object.keys(datetime).forEach((key) => {
        Vue.filter(key, datetime[key]);
    });

    Vue.prototype.$bus = eventBus;

    return new Vue({
        vuetify,
        store,
        router,
        el: element,
        render(createElement) {
            return createElement(app, {
                props: props,
            });
        },
    });
}

export default createApp;
